<template>
  <div class="pitemrowIso">
    <div class="pitemrowIso-item">
      <div class="imgright">
        <img :src="aimg" alt="">
      </div>
      <div class="content">
        <p class="title1">ISO文控管理系统</p>
        <p class="title2">系统涵盖了文件起草、升版、审核、培训、考核、发布、作废等全生命周期管理，能够帮助企业实现文件的规范化、标准化管理，确保文件的合规性、可追溯性和安全性</p>
        <ul>
          <li>
            <span class="management-icon" style="background-position:0 0"></span>
            <div class="text">
              <h3>全周期受控，闭环化管理</h3>
              <p>文件起草 → 多级审批 → 自动盖受控章 → 发布推送</p>
            </div>
          </li>
          <li>
            <span class="management-icon" style="background-position:0 -24px"></span>
            <div class="text">
              <h3>文控培训一体化</h3>
              <p>培训联动 → 在线考试 → 成绩归档 → 旧版回收</p>
            </div>
          </li>
          <li>
            <span class="management-icon" style="background-position:0 -48px"></span>
            <div class="text">
              <h3>有效执行，保障合规追溯</h3>
              <p>升版修订 / 作废申请 → 版本追溯 → 历史归档</p>
            </div>
          </li>
        </ul>
        <router-link :to="'/products/27'">
          <el-button type="primary" style="margin-top:1.5rem" @click="openConsultBox">免费试用</el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>


import arrow from '../assets/arrow-right.png'
import a from '../assets/软件产品ISO文控.png'
import { get, imageFile } from '../plugins/request.js'
import getQueryString from '../plugins/getQueryString.js'
import axios from "axios"

export default {
  name: 'PItemRow2',
  data() {
    return {
      msg:{
        title: '',
        subTitle: ''
      },
      aimg:a,
      arrow: arrow,
      item3:''
    }
  },
  components: {
   
  },
  methods: {
    openConsultBox(){
      window.$crisp.push(['do', 'chat:open']);
    },
  },
  created: function(){
    
      
  },
  watch: {
    '$route': function(to, from) {
      const id = this.$store.state.currentLanguage.id
      
    }
  }
}
</script>

<style lang="scss">
.pitemrowIso {
  max-width: 1440px;
  margin: 2rem auto;
  margin-bottom: 5rem;
  .pitemrowIso-item{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    max-width: 1440px;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .content{
    width: 23.6rem;
    margin-top: 2rem;
    .title1{
      font-size: 1.6rem;
      margin-bottom: 1rem;
      font-weight: 600;
    }
    .title2{
      font-size: 0.8rem;
      margin-bottom: 2.5rem;
      color:#666666;
      line-height: 1.7;
    }
    ul{
      width: 100%;
      li{
        display: inline-block;
        margin-right: 0.8rem;
        margin-bottom:1rem;
        font-size: 0.7rem;
        width: 100%;
        .management-icon{
          display: inline-block;
          width: 24px;
          height: 24px;
          background-image: url(../assets/序号123.png);
          border: 0;
          margin-bottom: 0.5rem;
          margin-right: 1rem;
        }
        .text{
          display: inline-block;
          h3{
            padding-bottom: 4px;
          }
        }
      }
    }
  }
  .imgright{
    margin-top: 2rem;
    img{
      background-color: white;
      box-shadow: 1px 2px 15px rgba(157, 183, 206, 0.5);
      border-radius: 21px;
    }
  }
}
</style>